module.exports = __webpack_public_path__ + "static/news (4)-56d47408d422aac239fd4193ee48d3de.jpg";